module.exports = __webpack_public_path__ + "img/cooperate_zf_05@2x.707fc5cf.png";